/**
 * Layout + elevation — maps to CSS variables in `tokens.css`.
 */
export const tokens = {
  page: {
    gutterX: 'var(--wp-page-gutter-x)',
    gutterY: 'var(--wp-space-16)',
  },
  radius: {
    card: 'var(--wp-radius-comfortable)',
    prominent: 'var(--wp-radius-featured)',
  },
  card: {
    padding: 'var(--wp-space-16)',
    paddingSmall: 'var(--wp-space-12)',
  },
  shadow: {
    popover: 'var(--wp-shadow-card)',
    elevated: 'var(--wp-shadow-ambient)',
  },
  typography: {
    badgeUppercasePx: 10,
    code: 'var(--wp-font-mono)',
    displayFontFamily: 'var(--wp-font-display)',
    uiFontFamily: 'var(--wp-font-body)',
  },
  icon: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
  },
  media: {
    /** SSOT — matches `--wp-bp-md-max` in tokens.css */
    mdMax: '(max-width: 47.99em)',
    mdMin: '(min-width: 48em)',
  },
} as const;
